import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DismissingLightAlert } from "../../../../Constant";
import { DISMISSING_LIGHT_DATA } from "../../../../Data/UiKit/Alert";
import { Bell } from "react-feather";
import { Alerts, Btn, P } from "../../../../AbstractElements";

const DismissingLightAlerts = () => {
  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);
  
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={DismissingLightAlert} span={DISMISSING_LIGHT_DATA} />
        <CardBody>
          <Alerts fade color="warning" isOpen={visible} className="alert-dismissible">
            <Bell />
            <P>Hidden content You should check in on some of those fields below.</P>
            <Btn className="btn-close" onClick={onDismiss}></Btn>
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DismissingLightAlerts;
